import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation, useAuthSession } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';
import { AuthLayout } from './auth-layout';

/** Post-email-verification landing page. `detectSessionInUrl: true` on the
 *  Supabase client already consumes the hash fragment; this route waits
 *  for the session to hydrate and redirects onwards. */
export function CallbackRoute() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { session, isLoading } = useAuthSession(supabase);

  useEffect(() => {
    if (isLoading) return;
    navigate(session ? '/dashboard' : '/auth/signin', { replace: true });
  }, [isLoading, session, navigate]);

  return (
    <AuthLayout title={t('auth.callback.title')} testId="auth-callback">
      <p className="text-muted-foreground text-start">{t('common.loading')}</p>
    </AuthLayout>
  );
}
